






































































import CheckBox from "@/components/basic/fields/CheckBox.vue";
import Radio from "@/components/basic/fields/Radio.vue";
import Field from "@/components/basic/fields/Field.vue";
import { mapState } from "vuex";
import { NoTinReason } from "@/constants/form-values";

export default {
  name: "NoTinField",
  props: {
    name: String,
  },
  data() {
    return {
      NoTinReason,
      formData: {
        noTinNumber: false,
        noTinNumberReason: null as null | NoTinReason,
        noTinNumberOtherReason: "" as string,
      },
      TRANSLATION_KEY: "compositeFields.NoTinField",
    };
  },
  mounted() {
    setTimeout(() => (this as any).setNoTinNumberOtherReasonFromBackEnd(), 500);
  },
  methods: {
    setNoTinReason(value: NoTinReason): void {
      (this as any).formData.noTinNumberReason = value;
      if(value !== 3) {
          (this as any).formData.noTinNumberOtherReason = "";
      }
    },
    emitData(): void {
      (this as any).$emit("input", (this as any).formData);
    },
    setNoTinNumberOtherReasonFromBackEnd(): void {
      const inputsRadio = document.querySelectorAll(`input[name=${(this as any).name}Reason]`);

      if ((this as any).taxResidenceData.hasOwnProperty("secondNoTinNumber")) {
        if ((this as any).taxResidenceData.secondNoTinNumber) {
          const reason = (this as any).taxResidenceData.secondNoTinNumberReason;
          if(inputsRadio.length > 0) {
            (inputsRadio[reason - 1] as HTMLFormElement).checked = true;
            (this as any).formData.noTinNumberReason = reason;
          }
        }
      }
    },
  },
  watch: {
    "formData.noTinNumber"(): void {
      (this as any).emitData();
    },
    "formData.noTinNumberReason"(): void {
      (this as any).emitData();
    },
    "formData.noTinNumberOtherReason"(): void {
      (this as any).emitData();
    },
  },
  computed: {
    ...mapState({
      taxResidenceData: (state: any) => state.formData,
    }),
  },
  components: {
    CheckBox,
    Radio,
    Field,
  },
};
